export default {
  left_column: {
    title: 'Tjek saldo',
    description: 'Indtast din gavekortkode for at se den resterende saldo. Koden findes på dit gavekort som PDF.',
  },
  title: 'Tjek gavekortets saldo',
  subtitle: 'Indtast en gavekortkode for at se den aktuelle saldo',
  error: {
    title: 'Gavekortet blev ikke fundet!',
    description: 'Indtast en gyldig gavekortkode.',
  },
  gift_card: {
    title: 'Gavekortet blev fundet!',
    balance: 'Saldo',
    value: 'Værdi',
    expires_at: 'Udløber',
  },
  form: {
    code: {
      label: 'Gavekortkode',
    },
  },
  buttons: {
    check_balance: 'Tjek saldo',
  },
};
